import React from 'react';
import { useNavigate } from 'react-router-dom';

const ValueProp = () => {
  const navigate = useNavigate();
  
  return (
    <section className="value-prop dark-section">
      <div className="container">
        <div className="split-content">
          <div className="content-left">
            <h2>Stop Losing $500k+<br />Per Year to Insurance<br />Carriers</h2>
            <p>Mandatory renters insurance generates millions in premiums — but property managers have been forced to outsource this revenue stream to third-party carriers, relinquishing control over underwriting economics, claims decisions, and the resident insurance experience. Owners can now capitalize on this opportunity to provide superior coverage with affordable premiums.</p>
            <button 
              className="btn-outline-light"
              onClick={() => navigate('/schedule-call')}
            >
              Schedule a Call
            </button>
          </div>
          <div className="content-right">
            <div className="captive-box">
              <p>With CaptiveWorks, you take control. We help you form, fund, and operate your own insurance captive so you own the risk, retain the profit and align coverage with your portfolio's needs.</p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default ValueProp;
